<template>
  <div class="widget-wrapper">
    <transition name="expand" mode="out-in">
      <button
        @click="openForm"
        :class="['button', 'is-rounded', 'is-medium', 'is-outlined', { 'is-loading circle': loading }, 'm-4']"
      >
        <span v-if="!loading" class="is-hidden-mobile">Get in touch</span>
        <span v-if="!loading" class="icon is-small mx-0">
          <i class="fas fa-comment-dots"></i>
        </span>
      </button>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: false
    };
  },
  methods: {
    openForm() {
      this.form = !this.form;
      this.loading = !this.loading;
      this.$emit("click", this.form);
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: true
    }
  }
};
</script>

<style scoped>
.is-loading {
  transition: max-height 0.25s ease-out;
  width: 3.25rem;
  transition-property: width;
}

.expand-enter-active,
.expand-leave-active {
  transition-property: width;
  transition-duration: 0.5s;
}

button {
  transition: max-height 0.25s ease-out;
  transition-property: width;

  background: #333333;
  border: 2px solid #00c5fd !important;
  width: auto;
  height: 3.25rem;
}

@media (max-width: 768px) {
  button {
    position: absolute;
    left: 0;
    top: 10%;
  }
}

span {
  color: white;
}
</style>

